const constants = {},
  SHEET_NAME = "Sheet",
  SHEET_HANDLE_NAME = "SheetHandle",
  SHEET_OVERLAY_NAME = "SheetOverlay";
export { SHEET_HANDLE_NAME, SHEET_NAME, SHEET_OVERLAY_NAME, constants };
//# sourceMappingURL=constants.mjs.map
